// tslint:disable:no-console no-param-reassign
import logger from '../logger';

export enum EventScope {
  INVENTORY = 'inventory',
  NEGOTIATION = 'negotiation',
  CREATE_OFFER = 'createOffer',
}

export type SnowplowContext = Window & {
  snowplow: any;
  snowplowQueue: any;
  // [CLARITY REMOVED] clarity?: any;
};

type Params = {
  context?: Window;
  event: string;
  label?: string;
  params?: { [key: string]: any };
  scope: string;
};

const addToSnowplowQueue = (context: SnowplowContext) => (...args: any) => {
  context.snowplowQueue = context.snowplowQueue || [];
  context.snowplowQueue.push(args);
};

// [CLARITY REMOVED] - flattenParams was only used for Clarity event tracking.
// const flattenParams = (obj: any, prefix = ''): Record<string, any> => {
//   return Object.entries(obj || {}).reduce((acc, [key, value]) => {
//     const newKey = prefix ? `${prefix}_${key}` : key;
//     if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
//       Object.assign(acc, flattenParams(value, newKey));
//     } else {
//       acc[newKey] = value;
//     }
//     return acc;
//   }, {} as Record<string, any>);
// };

const trackEvent = ({
  context = window,
  event,
  label = '',
  params,
  scope,
}: Params) => {
  const {
    localStorage,
    snowplow = addToSnowplowQueue(context as SnowplowContext),
  } = context as SnowplowContext;

  if (!scope || !event) {
    console.error(
      'Lib/trackEvent was called without a scope name or event name',
    );
    return;
  }

  let userId;

  try {
    const userData: any = localStorage.getItem('me');
    userId = JSON.parse(userData).uuid;
  } catch (error) {
    console.warn('Lib/trackEvent could not parse user id from localStorage');
  }

  if (process.env.DEBUG_EVENT_TRACKING) {
    logger.log('Tracking Event', {
      scope,
      event,
      params,
      label,
      userId,
    });
  }

  const eventName = `${scope}:${event}`;

  // Snowplow tracking
  snowplow(
    'trackStructEvent',
    eventName,
    params ? JSON.stringify(params) : '',
    label || '',
    userId || '',
    '',
  );

  // [CLARITY REMOVED]
  // if (clarity && typeof clarity === 'function') {
  //   clarity('event', eventName, flattenParams(params));
  // }

  logger.info(eventName, params);
};

export default trackEvent;
